// NPM Imports
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import PropTypes from "prop-types";

// Action Imports
import { Tooltip } from "../../revvComponents";
import {
  DynamicFieldActions,
  QuotationActions,
  EditorActions,
  DocumentTemplateActions,
} from "../../actions";

import {
  updateDocumentClickedComponentID,
  updateHoveredDocumentSectionId,
} from "../../actions/DocumentActions/index";

// Utils import
import { getSelectedText } from "../../utils/draftUtils";

// Components Imports
import { Dropdown } from "../../commonComponents";
import { GlobalUtils } from "../../utils/index";

// Destructuring
const { addDynamicField } = DynamicFieldActions;
const { updateToolPaneData } = QuotationActions;
const { nukeActiveEditor } = EditorActions;
// Destructuring
const { hanldeCustomFieldPane } = DocumentTemplateActions;
const { checkFreePlan } = GlobalUtils;

class DynamicFieldButton extends React.Component {
  state = { showDropDown: false };

  componentDidMount = () => {
    document.addEventListener("mousedown", this._handleClick, false);
  };

  componentWillUnmount = () => {
    document.removeEventListener("mousedown", this._handleClick, false);
  };

  _handleClick = e => {
    if (this.node && this.node.contains(e.target)) e.preventDefault();
  };

  _handleDropDownAction = action => {
    switch (action) {
      case "select":
        this._onClick();
        break;
      case "create":
        this._onNavigateToCustom();
        break;
      default:
        console.debug("NOT FOUND");
    }
  };

  _onNavigateToCustom = () => {
    // Get User Seletected Text
    const { editorState, removeHighlightSelection, clickedActiveComponentId } =
      this.props;
    const selectedText = getSelectedText(editorState);
    // this.props.getCustomFieldType();
    this.props.hanldeCustomFieldPane(true, "dynamic-fields", "TEMPLATE");
    this.props.addDynamicField(
      this.props.component,
      this.props.editorState,
      selectedText,
      removeHighlightSelection,
      "CUSTOM",
    );
    this.props.updateHoveredDocumentSectionId(null);
    this.props.nukeActiveEditor();
    if (clickedActiveComponentId) {
      this.props.updateDocumentClickedComponentID(null, true, null);
    }
  };

  _getOptions = () => ({
    className: "",
    icon: "",
    iconType: "",
    options: [
      {
        id: "select-df",
        name: "Choose from existing",
        argument: null,
        icon: null,
        iconClassName: "",
        isBottomLine: false,
        action: () => this._handleDropDownAction("select"),
      },
      {
        id: "create-df",
        name: "Create custom field",
        argument: null,
        icon: null,
        iconClassName: "",
        isBottomLine: false,
        action: () => this._handleDropDownAction("create"),
      },
    ],
    position: "",
    selectedClassNameIdent: "",
    title: "",
  });

  _onClick = () => {
    // Get User Seletected Text
    const {
      editorState,
      highlightSelection,
      removeHighlightSelection,
      clickedActiveComponentId,
    } = this.props;
    const selectedText = getSelectedText(editorState);
    highlightSelection();
    this.props.updateToolPaneData(true, "dynamic-fields", "TEMPLATE");
    this.props.addDynamicField(
      this.props.component,
      this.props.editorState,
      selectedText,
      removeHighlightSelection,
      "SELECT",
    );
    this.props.updateHoveredDocumentSectionId(null);
    this.props.nukeActiveEditor();
    if (clickedActiveComponentId) {
      this.props.updateDocumentClickedComponentID(null, true, null);
    }
  };

  _showDropDown = () => {
    this.setState(prevstate => ({
      showDropDown: !prevstate.showDropDown,
    }));
  };

  render() {
    return (
      <div
        ref={ele => {
          this.node = ele;
        }}
        className="draft-edit-items"
        id="toolbar-dynamic-field-button"
        key="toolbar-dynamic-field-button">
        <Tooltip
          placement="left"
          // align={{
          //   offset: [3, 0],
          // }}
          overlay={
            this.props.isDynamicFieldAllowed(
              this.props.editorState,
              this.props.mode,
            )
              ? "Convert text into form fields. Form fields are placeholders for data that you can fill in a form, when creating documents."
              : "Select some text to covert it into a form field."
          }>
          <div className="draftJsToolbar__buttonWrapper__1Dmqh flex-view dynamicfield-button-style">
            <button
              type="button"
              className={`dynamicfield-button transparent ${
                !this.props.isDynamicFieldAllowed(this.props.editorState) &&
                "disabled"
              }`}
              data-test="dynamicfieldbutton-button"
              id="template-add-dynamic-field-btn"
              onMouseDown={
                this.props.isDynamicFieldAllowed(this.props.editorState)
                  ? this._onClick
                  : ""
              }>
              <i>
                <FontAwesomeIcon icon={["fas", "brackets"]} />
              </i>
              Add Form Field
            </button>
            <button
              type="button"
              className={`dynamicfield-button move-to-left transparent ${
                !this.props.isDynamicFieldAllowed(this.props.editorState) &&
                "disabled"
              }`}
              id="template-add-dynamic-field-btn"
              data-test="dynamicfieldbutton-angle-down-button"
              onMouseDown={
                this.props.isDynamicFieldAllowed(this.props.editorState)
                  ? this._showDropDown
                  : ""
              }>
              {!checkFreePlan(this.props.planType) && (
                <i>
                  <FontAwesomeIcon icon={["far", "angle-down"]} />
                </i>
              )}
            </button>
          </div>
        </Tooltip>
        {!checkFreePlan(this.props.planType) && (
          <Dropdown
            options={this._getOptions()}
            showDropdown={this.state.showDropDown}
          />
        )}
      </div>
    );
  }
}

DynamicFieldButton.propTypes = {
  // Props
  component: PropTypes.shape({}).isRequired,
  editorState: PropTypes.shape({}).isRequired,

  // Actions
  addDynamicField: PropTypes.func.isRequired,
};

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state, props) => {
  const { clickedActiveComponentId } = state.DocumentStore;
  const { billingInfo } = state.CommonStore;
  const planType = billingInfo.plan_type;
  return { clickedActiveComponentId, planType };
};

const mapDispatchToProps = {
  nukeActiveEditor,
  addDynamicField,
  hanldeCustomFieldPane,
  updateDocumentClickedComponentID,
  updateHoveredDocumentSectionId,
  updateToolPaneData,
};

export default connect(mapStateToProps, mapDispatchToProps)(DynamicFieldButton);
